import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"edit\">\n    <path id=\"edit_a\" d=\"M10.315 1.315h2v-1h-2v1zm0 2v12h2v-12h-2zm-1-5h4a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-17a1 1 0 0 1 1-1zm1.618 22l1.276 2.552a1 1 0 0 1-1.789.895l-2-4a1 1 0 0 1 .895-1.447h4a1 1 0 0 1 .894 1.447l-.588 1.176a1 1 0 0 1-1.88-.623h-.808z\" transform=\"rotate(45 11.315 11.315)\" fill=\"#CFCFCF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol